module.exports = __webpack_public_path__ + "static/media/preferences.5207994a.svg";